import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { Shift } from "@app/models/rest/roster/shift";

@Injectable({
  providedIn: "root"
})
export class ShiftRestService extends HateoasResourceOperation<Shift> {
  constructor() {
    super(Shift);
  }
}
